import type { SecretInputValue } from '@/components/atoms/SecretInput';
import {
    canonicalScadaText,
    type FieldValue,
    isListKind,
    type ProviderFieldSchema,
    type SecretName,
} from '@/domain/providerConfig';

export type FormFieldValue = string | string[];

export function emptyFormValue(field: ProviderFieldSchema): FormFieldValue {
    return isListKind(field.kind) ? [] : '';
}

/** What the form shows for a stored value: null becomes blank text or an empty list. */
export function toFormFieldValue(field: ProviderFieldSchema, value: FieldValue): FormFieldValue {
    if (isListKind(field.kind)) {
        if (Array.isArray(value)) return [...value];
        return typeof value === 'string' && value !== '' ? [value] : [];
    }
    if (typeof value !== 'string') return '';
    // Compared as text, so key order must not make an unchanged list look edited.
    return field.kind === 'scadaItems' ? canonicalScadaText(value) : value;
}

export function keepAllSecrets(): Record<SecretName, SecretInputValue> {
    return { apiKey: { mode: 'keep' }, clientId: { mode: 'keep' }, clientSecret: { mode: 'keep' } };
}
